module.exports = __webpack_public_path__ + "img/ML.84148fde.png";